import React, { PureComponent } from 'react'
import Button from 'aria-viewer/tour/components/buttons/button'
import Icon from 'aria-viewer/tour/components/icon'

class MapShrink extends PureComponent {
    render() {
        const { onClick, style } = this.props

        return (
            <Button
                id="mapMinArrow"
                aria-label="maximize map"
                onClick={onClick}
                style={Object.assign({}, style, { cursor: 'pointer' })}
            >
                <Icon
                    icon="arrowDown"
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        width: '100%',
                        transform: 'translate(-50%, -50%) rotateZ(90deg)',
                        backgroundSize: '50%',
                        ':hover': {
                            backgroundSize: '55%',
                        },
                    }}
                />
            </Button>
        )
    }
}

export default MapShrink
